import { Skeleton } from "@radix-ui/themes";
import { Flex } from "@radix-ui/themes";

const ProductSkeleton = ({ count = 3 }: { count?: number }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Flex key={index} gap="3" p="2" className="border rounded">
          <Skeleton width="60px" height="60px" />
          <Flex direction="column" gap="1" style={{ flex: 1 }}>
            <Skeleton height="16px" width="80%" />
            <Skeleton height="12px" width="60%" />
            <Skeleton height="12px" width="40%" />
            <Skeleton height="12px" width="30%" />
          </Flex>
        </Flex>
      ))}
    </>
  );
};

export default ProductSkeleton;
